import React, {useEffect, useRef, useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectCoverflow} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import './style.css'
import SwipeAnimation from "./SwipeAnimation";

const tabData = ({index, path, quantity, submenuIndex, childIndex}) => {
	const basePath = path || 'guild-step';
	const tabPrefix = `tab${index}`;
	const subSegment =
		submenuIndex != null && submenuIndex >= 0 ? `-sub${submenuIndex + 1}` : '';
	const childSegment =
		childIndex != null && childIndex >= 0 ? `-child${childIndex + 1}` : '';
	return Array.from({length: quantity ?? 0}).map((_, i) => {
		const stepNumber = i + 1;
		const src = `/img/${basePath}/${tabPrefix}${subSegment}${childSegment}-step${stepNumber}.png`;
		return {
			src,
			alt: `${tabPrefix}${subSegment}${childSegment}-step${stepNumber}`
		};
	});
};

const PhoneSwiper = ({activeTab, step, path, setStep, quantity, submenuIndex, childIndex}) => {
	const [checkInteraction, setCheckInteraction] = useState(false);
	const [data, setData] = useState(null);
	const swiperRef = useRef(null);
	useEffect(() => {
		setData(tabData({index: activeTab + 1, path, quantity, submenuIndex, childIndex}));
		const swiper = swiperRef.current?.swiper;
		if (swiper) {
			swiper.update();
			swiper.slideTo(0);
		}
	}, [activeTab, path, quantity, submenuIndex, childIndex]);
	
	useEffect(() => {
		if (step > 0 && !window.phoneInteraction) {
			window.phoneInteraction = true
			setCheckInteraction(true)
		}
		const swiper = swiperRef.current?.swiper;
		if (swiper && step !== swiper.activeIndex) {
			swiper.slideTo(step);
		}
	}, [step]);
	
	console.log('data', data)
	
	return (
		<div className="relative flex items-center justify-center w-[255px] h-[526px] bg-cover bg-center mx-auto">
			<img className='absolute' src="/img/phone.png" alt="phone"/>
			<img className='absolute z-[2] top-3' src="/img/phone-island.png" alt="phone-island"/>
			<div className="w-[242px] h-[516px] overflow-hidden rounded-[32px]">
				{
					(!checkInteraction || !window.phoneInteraction) && (
						<div className='md:hidden absolute bg-[#00000010] z-10 top-10 image-opacity h-[150px]'>
							<SwipeAnimation/>
						</div>
					)
				}
				
				<Swiper
					ref={swiperRef}
					className="w-full h-full"
					grabCursor={true}
					centeredSlides={true}
					slidesPerView={1}
					pagination={true}
					modules={[EffectCoverflow]}
					onSlideChangeTransitionEnd={swp => setStep(swp?.activeIndex || 0)}
				>
					{(data || []).map((image, index) => (
						<SwiperSlide key={index}>
							<img
								src={image.src}
								alt={image.alt}
								className="w-full h-full object-cover"
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};

export default PhoneSwiper;
